import { ICourseModulesNodes } from '@dtos/Course'

const hasContent = (module: ICourseModulesNodes): boolean => {
  // Check if module has content
  if (module.courseContentsCount > 0) return true

  // Check if any submodule has content
  if (module.courseModules?.length > 0) {
    return module.courseModules.some((submodule) => hasContent(submodule))
  }

  return false
}

export const filterAvailableModules = (
  modules: ICourseModulesNodes[],
): ICourseModulesNodes[] =>
  modules.filter((module) => module.available !== false && hasContent(module))
